/**
 * Что привело пользователя к форме входа: «не смог оформить заказ» и «зашёл в профиль» —
 * два разных чтения всей воронки авторизации.
 *
 * Живёт в shared, а не в features/auth: вход открывают корзина, профиль, подарки,
 * диплинки — фичи друг друга по FSD не импортируют, а shared доступен всем.
 * Ставить ПЕРЕД открытием модалки входа; модалка читает значение при открытии.
 */
let entryPoint = 'unknown'

export const setAuthEntryPoint = (source: string): void => {
  entryPoint = source
}

export const getAuthEntryPoint = (): string => entryPoint
